var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v35h35V0H0zm25.178 4.567a8.97 8.97 0 01.792.022c1.006.001 2.056.092 3.098.183l-.114 4.145h-2.798c-1.312-.03-1.786.48-1.829 1.96v3.256h4.74l-.187 4.44h-4.553V30.93h-4.625V18.572h-3.21v-4.439h3.21v-3.81c0-2.749 1.162-4.497 3.45-5.384.588-.231 1.263-.356 2.026-.372z",
    fill: "#fff"
  })));
}

export default SvgFacebook;